module.exports = __webpack_public_path__ + "img/스마트그늘막 (2).63606ca2.jpg";